import { render, staticRenderFns } from "./BottomFixed.vue?vue&type=template&id=0e18a4a8&scoped=true&"
import script from "./BottomFixed.vue?vue&type=script&lang=ts&"
export * from "./BottomFixed.vue?vue&type=script&lang=ts&"
import style0 from "./BottomFixed.vue?vue&type=style&index=0&id=0e18a4a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e18a4a8",
  null
  
)

export default component.exports